import { ComponentType, type FunctionComponent } from 'react'
import { OpenInNew } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { Link, LinkProps } from '@mui/material'

export const OpenInNewIcon: FunctionComponent = styled( OpenInNew )( ( { theme } ) => ( {
	marginLeft: theme.spacing( 0.2 ),
	fontSize: theme.typography.caption.fontSize,
} ) )

export const StyledLink: ComponentType<LinkProps> = styled( Link )( ( { theme } ) => ( {
	'textDecoration': 'none',
	'color': theme.palette.primary.main,
	'&:hover': {
		textDecoration: 'underline',
	},
} ) )
